/**
 * Sticky ATC bar for mobile PDP.
 * Shows a fixed bar at the viewport bottom when the native ATC scrolls out of view.
 * Clones the real Rivo wishlist button to get full like count + favouriting.
 */
(function() {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  function init() {
    var nativeForm = document.querySelector('product-form-component')
      || document.querySelector('add-to-cart-form')
      || document.querySelector('form[action*="/cart/add"]');
    if (!nativeForm) return;

    // Remove server-rendered placeholder
    var placeholder = document.querySelector('sticky-atc-bar');
    if (placeholder) placeholder.remove();

    // Match the inline ATC button height
    var inlineAtc = nativeForm.querySelector('button.add-to-cart-button, [type="submit"], button[name="add"]');
    var btnHeight = inlineAtc ? inlineAtc.offsetHeight : 48;

    // Clone the real like button (Rivo wishlist heart with count)
    var inlineLike = document.querySelector('.product-information .favorite-button-wrapper:not(.favorite-button-wrapper--compact)');
    var likeHtml = '';
    if (inlineLike) {
      var clone = inlineLike.cloneNode(true);
      // Override styles for sticky context
      clone.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:10px;padding:12px;background:#fff;border:1px solid rgba(0,0,0,0.1);border-radius:8px;cursor:pointer;flex:0 0 auto;min-width:fit-content;height:' + btnHeight + 'px;width:auto;position:static;margin:0;';
      // Force icon and count sizes to match inline
      var cloneSvg = clone.querySelector('svg');
      if (cloneSvg) {
        cloneSvg.style.cssText = 'width:26px!important;height:26px!important;min-width:26px!important;min-height:26px!important;position:static!important;stroke:#000!important;';
      }
      var cloneCount = clone.querySelector('.favorite-button-wrapper__count');
      if (cloneCount) {
        cloneCount.style.cssText = 'font-size:18px;font-weight:500;color:#000;line-height:1;pointer-events:none;position:static;';
      }
      likeHtml = clone.outerHTML;
    } else {
      // Fallback: simple heart SVG
      likeHtml = '<button id="sticky-atc-like" style="height:' + btnHeight + 'px;padding:0 12px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;display:flex;align-items:center;justify-content:center;background:#fff;cursor:pointer;flex-shrink:0">'
        + '<svg width="22" height="22" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 17.5s-7-4.5-7-9.5a4 4 0 0 1 7-2.8A4 4 0 0 1 17 8c0 5-7 9.5-7 9.5z"/></svg>'
        + '</button>';
    }

    // Create bar
    var bar = document.createElement('div');
    bar.id = 'sticky-atc-bar';
    bar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;z-index:9999;background:#fff;border-top:1px solid #e5e7eb;padding:8px 16px;padding-bottom:max(8px,env(safe-area-inset-bottom,0px));box-shadow:0 -2px 8px rgba(0,0,0,0.08);transform:translateY(100%);transition:transform 0.25s ease;pointer-events:none;';
    bar.innerHTML = '<div style="display:flex;align-items:center;gap:8px;max-width:600px;margin:0 auto;width:100%">'
      + likeHtml
      + '<button id="sticky-atc-btn" style="flex:1;height:' + btnHeight + 'px;background:#1d1d1f;color:#fff;border:none;border-radius:8px;font-family:inherit;font-size:14px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px">'
      + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="20" height="20" style="flex-shrink:0"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14.608 12.563v5m2.5-2.5h-5"></path></svg>'
      + '<span>Add to cart</span>'
      + '<span id="sticky-atc-price"></span>'
      + '</button>'
      + '</div>';

    document.body.appendChild(bar);

    // Re-initialize Rivo for the cloned button
    if (inlineLike && window.RivoProfileAlpine) {
      try {
        var rivoWidget = document.getElementById('rivo-account-slideout');
        if (rivoWidget) {
          window.RivoProfileAlpine.$data(rivoWidget).initializeFavoriteButtons();
        }
      } catch (e) { /* Rivo not ready yet */ }
    }

    var priceEl = bar.querySelector('#sticky-atc-price');
    var btn = bar.querySelector('#sticky-atc-btn');

    // Show sticky bar only when the inline ATC has scrolled ABOVE the viewport
    // (user has scrolled past it), not when it's below (user hasn't reached it yet)
    var observer = new IntersectionObserver(function(entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        bar.style.transform = 'translateY(100%)';
        bar.style.pointerEvents = 'none';
      } else if (entry.boundingClientRect.top < 0) {
        // Form is above viewport — user scrolled past it
        bar.style.transform = 'translateY(0)';
        bar.style.pointerEvents = 'auto';
      }
    }, { threshold: 0 });
    observer.observe(nativeForm);

    // ATC click delegates to native form
    btn.addEventListener('click', function() {
      var nativeBtn = nativeForm.querySelector('button.add-to-cart-button, [type="submit"], button[name="add"]');
      if (nativeBtn) nativeBtn.click();
      document.dispatchEvent(new CustomEvent('sticky-atc:clicked', { bubbles: true }));
    });

    // Fallback like click (if Rivo clone didn't work)
    var fallbackLike = bar.querySelector('#sticky-atc-like');
    if (fallbackLike) {
      fallbackLike.addEventListener('click', function() {
        var nativeLike = document.querySelector('.product-information .favorite-button-wrapper:not(.favorite-button-wrapper--compact) rivo-favorite-button');
        if (nativeLike) nativeLike.click();
      });
    }

    // Price sync
    function syncPrice() {
      var el = document.querySelector('.price-current, .price-item--sale, .price-item--regular');
      if (el && priceEl) priceEl.textContent = '— ' + el.textContent.trim();
    }
    syncPrice();
    setTimeout(syncPrice, 500);
    setTimeout(syncPrice, 1500);
    function syncPriceDeferred() { setTimeout(syncPrice, 60); }
    document.addEventListener('size-impact:changed', syncPrice);
    document.addEventListener('abstractVariantChange', syncPrice);
    document.addEventListener('style-picker:preset-selected', syncPriceDeferred);
    document.addEventListener('style-picker:custom-applied', syncPriceDeferred);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
